import { render } from "./work-content-and-development.vue?vue&type=template&id=171b1afd&scoped=true"
import script from "./work-content-and-development.vue?vue&type=script&lang=js"
export * from "./work-content-and-development.vue?vue&type=script&lang=js"

import "./work-content-and-development.vue?vue&type=style&index=0&id=171b1afd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b1afd"],['__file',"src/components/applications/workorganisation/work-content-and-development.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "171b1afd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('171b1afd', __exports__)) {
    api.reload('171b1afd', __exports__)
  }
  
  module.hot.accept("./work-content-and-development.vue?vue&type=template&id=171b1afd&scoped=true", () => {
    api.rerender('171b1afd', render)
  })

}


export default __exports__